import * as React from 'react';
import BulkLeadImport from '../../../application/routes/settings/components/BulkLeadImport/BulkLeadImport';
import { PageHeader } from '../../components/page-header';
import { V2MobileNav } from '../../components/v2-mobile-nav';

/**
 * V2 wrapper for the existing BulkLeadImport component.
 * Applies CSS class scoping to restyle MUI components to match the shadcn/v2 design.
 * No functional changes to the underlying component.
 */
export function BulkLeadImportPage() {
  return (
    <div className="flex flex-col h-full overflow-hidden">
      <PageHeader title="Bulk Lead Import" />
      <V2MobileNav />
      <div className="flex-1 overflow-y-auto">
        <div className="v2-bulk-import max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 py-4 sm:py-6">
          <BulkLeadImport />
        </div>
      </div>
    </div>
  );
}
